import { FC } from "react";

type IneligibleTitleNoticeProps = {
  title: string;
};

export const IneligibleTitleNotice: FC<IneligibleTitleNoticeProps> = ({
  title,
}) => <p className="small fw-semibold text-muted">{title}</p>;
